export interface ISelectOption {
  label: string;
  value: string | number;
}

export interface IBrand {
  id?: string;
  name: string;
}

export const ContentCodeOptions = [
  { id: "PR", name: "Product Review" },
  { id: "HT", name: "HowTo" },
  { id: "CU", name: "Curation" },
  { id: "MP", name: "Meet The Pro" },
  { id: "CP", name: "Class Package" },
  { id: "CL", name: "Class" },
  { id: "FS", name: "Founder Story" },
  { id: "IN", name: "Interviews" },
  { id: "WB", name: "Whats In My Bag" },
];
